export const API_URL = window.location.hostname;
export const API_SERVER = window.location.hostname + ':7000';
export const API_HOST = 'https://iot.innovation.com.vn';
export const API_DOCUMENT = 'https://helper.innovation.com.vn/api';

export const IMG_URL = process.env.PUBLIC_URL + '/images';

export const page = 0;
export const pageSize = 1000;

export const PageURL = {
  DASHBOARD: '/',
  DEVICE: '/device/:customer_id',
  DOCUMENT: '/document',
  AUTH_SIGNIN: '/',
  CUSTOMERS: '/customers',
  USERS: '/customers/:customer_id',
  PROFILE: '/profile',
  ATTRIBUTE: '/attribute/:device_id',
  MAP: '/map',
  REPORT: '/report',
  ALARM: '/alarm',
  PAGENOTFOUND: '/404',
};
